import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { commonURI, commonUriAll } from '../CommonUrlList/CommonUrlList'
import { addpricebtn, clearMaster, fetchEventMasterWise, loaderStart, loaderStop } from '../features/HomeMaster'
import { DecryptOrderFunction, encryptAES256, EncryptOrderFun } from '../features/CryptoJsService'

export const EventGame = () => {
    const pricebtn = [0, 5000, 10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000, 55000, 60000, 65000, 70000, 75000, 80000, 85000, 90000, 95000, 100000, 200000]
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const homeMaster = useSelector(state => state.homeMaster?.master)
    const sessionData = JSON.parse(sessionStorage.getItem('userData') || '{}')
    const [pricesData, setPData] = useState([])
    const [query, setQuery] = useState('')
    const [modalB, setModalB] = useState(true)
    const [message, setmessage] = useState('')
    const [messagemodal, setmessagemodal] = useState(false)
    const [closeHorse, setCloseHorse] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const queryParameters = new URLSearchParams(window.location.search)
    const eventId = queryParameters.get('eventId')
    const sportId = queryParameters.get('sportId')
    const location = useLocation()
    const updateIntervalRef = useRef()
    const selectedMid = sessionStorage.getItem(sessionData.stUserName + '_selectedMid')
    const broadcastIntervalRef = useRef()
    async function updateMessage(id, message) {
        try {
            const response = await fetch(`https://nodebb.radhe99.com/api/message/${id}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ message })
            });

            const data = await response.json();
            return data; // { status: 'success', message: 'Updated' }
        } catch (error) {
            console.error("Error updating message:", error);
            throw error;
        }
    }

    const dateFormater = (date, separator, day) => {
        const dayNum = date.getDate()
        const month = date.getMonth() + 1
        const year = date.getFullYear()
        return `${year}${separator}${month < 10 ? '0' + month : month}${separator}${dayNum < 10 ? '0' + dayNum : dayNum}`
    }
    const timeFormate = (date) => {
        const hours = date.getHours()
        const minutes = date.getMinutes()
        const seconds = date.getSeconds()
        return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`
    }
    const fetchAndUpdateHomeMaster = async () => {
        try {
            const response = await dispatch(fetchEventMasterWise())
            if (response.payload) {
                const suspendedMarkets = JSON.parse(localStorage.getItem('suspendedMarkets') || '[]')
                // Update with saved prices if available
                const updatedData = response.payload.map(market => {
                    // Skip updates for suspended markets
                    let sus = false
                    if (suspendedMarkets?.includes(market.stMarketID)) {
                        sus = true
                    }

                    // const savedPrices = JSON.parse(localStorage.getItem('savedata'))?.find(item => item.stMarketID === market.stMarketID)
                    // if (savedPrices) {
                    return {
                        ...market,
                        btMarketStatus: sus ? 2 : 1,
                        submaster: market.submaster.map(runner => ({
                            ...runner,
                            btRunnarStatus: sus ? 2 : 1,
                            rates: {
                                Back: [
                                    {
                                        "Price": parseFloat(document.getElementById("selectback1_" + runner.stInstrumentID)?.value || '0'),
                                        "Size": parseFloat(document.getElementById("selectback1_" + runner.stInstrumentID)?.value || '0') == 0 ? 0 : parseFloat(document.getElementById(market.stMarketID + "_marketqty")?.value || '0')
                                    },
                                    // {
                                    //     Price: savedPrices[runner.stSelectionID + "_bprice"] || runner.rates.Back[0].Price,
                                    //     Size: savedPrices[runner.stSelectionID + "_bsize"] || runner.rates.Back[0].Size
                                    // }
                                ],
                                Lay: [
                                    {
                                        "Price": parseFloat(document.getElementById('layrun1_' + runner.stInstrumentID)?.value || '0'),
                                        "Size": parseFloat(document.getElementById('layrun1_' + runner.stInstrumentID)?.value || '0') == 0 ? 0 : parseFloat(document.getElementById(market.stMarketID + "_marketqty")?.value || '0')
                                    },
                                    // {
                                    //     Price: savedPrices[runner.stSelectionID + "_lprice"] || runner.rates.Lay[0].Price,
                                    //     Size: savedPrices[runner.stSelectionID + "_lsize"] || runner.rates.Lay[0].Size
                                    // }
                                ]
                            }
                        }))
                    }
                    // }
                    // return market
                })
                localStorage.setItem('manageb', JSON.stringify(updatedData))
            }
        } catch (error) {
            console.error("Update error:", error)
        } finally {
            updateIntervalRef.current = setTimeout(fetchAndUpdateHomeMaster, 1000)
        }
    }
    const openClosingHorse = async (element) => {
        const mainOBJ = {
            "stMarketID": element.stMarketID,
            "selectionDepth": [],
            "dbLTP": 0.0,
            "dbMatched": 0.0,
            "btMarketStatus": 1,
            "stType": 13,
            "gameStage": 0,
            "dtLastUpdated": dateFormater(new Date(), "-") + " " + timeFormate(new Date())
        }

        for (let i = 0; i < element.submaster?.length; i++) {
            const element2 = element.submaster[i]
            mainOBJ.selectionDepth.push({
                "stSelectionID": element2.stSelectionID,
                "stInstrumentID": element2.stInstrumentID,
                "Back": [
                    {
                        "Price": parseFloat(document.getElementById("selectback1_" + element2.stInstrumentID)?.value || '0'),
                        "Size": parseFloat(document.getElementById("selectback1_" + element2.stInstrumentID)?.value || '0') == 0 ? 0 : parseFloat(document.getElementById("selectbacks_" + element2.stInstrumentID)?.value || '0')
                    },
                    { "Price": 0.0, "Size": 0.0 },
                    { "Price": 0.0, "Size": 0.0 }
                ],
                "Lay": [
                    {
                        "Price": parseFloat(document.getElementById('layrun1_' + element2.stInstrumentID).value || '0'),
                        "Size": parseFloat(document.getElementById('layrun1_' + element2.stInstrumentID).value || '0') == 0 ? 0 : parseFloat(document.getElementById("layruns_" + element2.stInstrumentID)?.value || '0')
                    },
                    { "Price": 0.0, "Size": 0.0 },
                    { "Price": 0.0, "Size": 0.0 }
                ],
                "btRunnarStatus": document.getElementById("horsestat_" + element2.stSelectionID)?.value,
                'adjustmentFactor': document.getElementById("adfac_" + element2.stSelectionID)?.value,
                'extraMark': document.getElementById("exremwin_" + element2.stSelectionID)?.value
            })
        }
        try {
            // First API call
            const heroResponse = await fetch('https://masterpg.9xxbet.com/api/v1/result/postresultnormal', {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ mid: element.stMarketID, sid: "Delete" })
            })
            const heroResult = await heroResponse.json()
            if (heroResult.status === "success") {
                toast.success("Result Uploaded successfully to hero")
            } else {
                toast.error("Error: result is not added to hero")
            }

            // Second API call
            const indResponse = await fetch('https://postg.9xxbet.com/api/v1/result/postresultind', {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ data: mainOBJ })
            })
            const indResult = await indResponse.json()
            if (indResult.status === "success") {
                toast.success("Result Uploaded successfully to hero")
            } else {
                toast.error("Error: result is not added to hero")
            }

            setCloseHorse(null)
        } catch (error) {
            // toast.error("Server Error 500")
            console.error('API error:', error)
        }
    }
    const selectedpricebtn = useSelector(state => state.homeMaster.pricebtn)

    const addTossMarketPrice = async (element) => {
        const mainOBJ = {
            "stMarketID": element.stMarketID,
            "selectionDepth": [],
            "dbLTP": 0.0,
            "dbMatched": 0.0,
            "btMarketStatus": element.btMarketStatus,
            "stType": 13,
            "gameStage": 0,
            "dtLastUpdated": dateFormater(new Date(), "-") + " " + timeFormate(new Date())
        }
        for (let i = 0; i < element.submaster?.length; i++) {
            const element2 = element.submaster[i]
            var runnerStatus = sessionStorage.getItem(element2.stInstrumentID)
            runnerStatus = runnerStatus ? parseFloat(runnerStatus) : undefined
            mainOBJ.selectionDepth.push({
                "stSelectionID": element2.stSelectionID,
                "stInstrumentID": element2.stInstrumentID,
                "Back": [
                    {
                        "Price": parseFloat(document.getElementById("selectback1_" + element2.stInstrumentID)?.value || '0'),
                        "Size": parseFloat(document.getElementById("selectback1_" + element2.stInstrumentID)?.value || '0') == 0 ? 0 : parseFloat(document.getElementById("selectbacks_" + element2.stInstrumentID)?.value || '0')
                    },
                    { "Price": 0.0, "Size": 0.0 },
                    { "Price": 0.0, "Size": 0.0 }
                ],
                "Lay": [
                    {
                        "Price": parseFloat(document.getElementById('layrun1_' + element2.stInstrumentID)?.value || '0'),
                        "Size": parseFloat(document.getElementById('layrun1_' + element2.stInstrumentID)?.value || '0') == 0 ? 0 : parseFloat(document.getElementById("layruns_" + element2.stInstrumentID)?.value || '0')
                    },
                    { "Price": 0.0, "Size": 0.0 },
                    { "Price": 0.0, "Size": 0.0 }
                ],
                "btRunnarStatus": runnerStatus ?? element2.btRunnarStatus
            })
        }
        let oldSaveData = JSON.parse(localStorage.getItem('manageb') || [])
        const updatedData = oldSaveData.map(item =>
            item.stMarketID === mainOBJ.stMarketID ? mainOBJ : item
        )
        localStorage.setItem('manageb', JSON.stringify(updatedData))
        try {
            if (mainOBJ.selectionDepth.length === 0) {
                return
            }
            console.log(mainOBJ);
            
            const encryptedData = encryptAES256(JSON.stringify(mainOBJ))
            const response = await fetch("https://masterpg.9xxbet.com/api/v1/master/addbrodcast", {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    authorization: "Bearer " + sessionData.token
                },
                body: JSON.stringify({ data: encryptedData })
            })
            const result = await response.json()
            if (!result.success) {
                toast.error("Error: Broadcast is not added")
            }
        } catch (error) {
            // toast.error("Server Error 500")
            console.error('Broadcast error:', error)
        }
    }
    const suspendHorse = async (element, status) => {
        try {
            if (status === 2) {
                let suspendedMarkets = JSON.parse(localStorage.getItem('suspendedMarkets') || '[]')
                if (!suspendedMarkets?.includes(element.stMarketID)) {
                    suspendedMarkets.push(element.stMarketID)
                }
                localStorage.setItem('suspendedMarkets', JSON.stringify(suspendedMarkets))
            }
            const savedPrices = JSON.parse(localStorage.getItem('savedata'))?.find(a => a.stMarketID === element.stMarketID)
            if (!savedPrices) {
                // toast.error("No saved prices found for this market")
                return
            }
            const mainOBJ = {
                "stMarketID": element.stMarketID,
                "selectionDepth": [],
                "dbLTP": 0.0,
                "dbMatched": 0.0,
                "btMarketStatus": status,
                "stType": 13,
                "gameStage": 0,
                "dtLastUpdated": dateFormater(new Date(), "-") + " " + timeFormate(new Date())
            }
            for (let i = 0; i < element.submaster?.length; i++) {
                const element2 = element.submaster[i]
                mainOBJ.selectionDepth.push({
                    "stSelectionID": element2.stSelectionID,
                    "stInstrumentID": element2.stInstrumentID,
                    "Back": [
                        {
                            "Price": parseFloat(document.getElementById("selectback1_" + element2.stInstrumentID)?.value || '0'),
                            "Size": parseFloat(document.getElementById("selectback1_" + element2.stInstrumentID)?.value || '0') == 0 ? 0 : parseFloat(document.getElementById("selectbacks_" + element2.stInstrumentID)?.value || '0')
                        },
                        // {
                        //     "Price": savedPrices[element2.stSelectionID + "_bprice"],
                        //     "Size": savedPrices[element2.stSelectionID + "_bsize"]
                        // },
                        { "Price": 0.0, "Size": 0.0 },
                        { "Price": 0.0, "Size": 0.0 }
                    ],
                    "Lay": [
                        {
                            "Price": parseFloat(document.getElementById('layrun1_' + element2.stInstrumentID)?.value || '0'),
                            "Size": parseFloat(document.getElementById('layrun1_' + element2.stInstrumentID)?.value || '0') == 0 ? 0 : parseFloat(document.getElementById("layruns_" + element2.stInstrumentID)?.value || '0')
                        },
                        // {
                        //     "Price": savedPrices[element2.stSelectionID + "_lprice"],
                        //     "Size": savedPrices[element2.stSelectionID + "_lsize"]
                        // },
                        { "Price": 0.0, "Size": 0.0 },
                        { "Price": 0.0, "Size": 0.0 }
                    ],
                    "btRunnarStatus": status
                })
            }
            let oldSaveData = JSON.parse(localStorage.getItem('manageb') || '[]')
            const updatedData = oldSaveData.map(item =>
                item.stMarketID === mainOBJ.stMarketID ? { ...item, btMarketStatus: status } : item
            )
            localStorage.setItem('manageb', JSON.stringify(updatedData))
            if (mainOBJ.selectionDepth.length === 0) {
                return
            }
            const encryptedData = encryptAES256(JSON.stringify(mainOBJ))
            const response = await fetch("https://masterpg.9xxbet.com/api/v1/master/addbrodcast", {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    authorization: "Bearer " + sessionData.token
                },
                body: JSON.stringify({ data: encryptedData })
            })
            const result = await response.json()
            if (!result.success) {
                toast.error("Error: Broadcast is not added")
            }
        } catch (error) {
            // toast.error("Error suspending market")
            console.error("Suspend error:", error)
        }
    }
    let susMarkets = JSON.parse(localStorage.getItem('suspendedMarkets') || '[]')
    const resumeMarket = async (marketId) => {
        let suspendedMarkets = JSON.parse(localStorage.getItem('suspendedMarkets') || '[]')
        if (suspendedMarkets?.includes(marketId)) {
            suspendedMarkets = suspendedMarkets.filter(x => x !== marketId)
        }
        localStorage.setItem('suspendedMarkets', JSON.stringify(suspendedMarkets))
    }
    useEffect(() => {
        const timer = setTimeout(() => {
            if (query) {
                addTossMarketPrice(query)
            }
        }, 1000)
        return () => clearTimeout(timer)
    }, [query])
    const timeRunner = async () => {
        const savedData = JSON.parse(localStorage.getItem('manageb') || '[]')
        for (let i = 0; i < savedData.length; i++) {
            const element = savedData[i];
            const selectedMid = sessionStorage.getItem(sessionData.stUserName + '_selectedMid')

            if (selectedMid && selectedMid != '' && element.stMarketID == selectedMid) {
                await addTossMarketPrice(element)
            }
        }
        broadcastIntervalRef.current = setTimeout(() => {
            timeRunner()
        }, 1000)
    }
    useEffect(() => {
        sessionStorage.removeItem(sessionData.stUserName + '_selectedMid')
        window.scroll(0, 0)
        localStorage.setItem('manageb', JSON.stringify([]))
        dispatch(clearMaster())
        dispatch(loaderStart())
        const initializeData = async () => {
            const response = await dispatch(fetchEventMasterWise())
            if (response.payload) {
                const matchOdds = response.payload.find(a => a.stMarketName === "Match Odds")
                if (matchOdds) {
                    sessionStorage.setItem('oddsid', matchOdds.stMarketID)
                }
                localStorage.setItem('manageb', JSON.stringify(response.payload))
            }
            dispatch(loaderStop())
        }
        initializeData()
        updateIntervalRef.current = setTimeout(fetchAndUpdateHomeMaster, 1000)
        broadcastIntervalRef.current = setTimeout(() => {
            timeRunner()
        }, 1000)
        return () => {
            clearTimeout(updateIntervalRef.current)
            clearTimeout(broadcastIntervalRef.current)
            localStorage.setItem('manageb', JSON.stringify([]))
        }
    }, [location.search])

    return (
        <>
            {modalB && (
                <div
                    id="manual-manga-markets5"
                    role="dialog"
                    className="modal modal-fullscreen-sm-down fade show"
                    style={{ display: "block" }}
                >
                    <div className="modal-dialog modal-fullscreen">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header bg-dark text-white">
                                <h1 className="modal-title fs-4">Manage Manual Markets</h1>
                                {homeMaster?.map((d) => (
                                    <button
                                        key={d.stMarketID}
                                        onClick={() => {
                                            suspendHorse(d, 2);
                                            navigate("/home");
                                        }}
                                        type="button"
                                        className="btn-close btn-close-white"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    />
                                ))}
                            </div>
                            <div>
                                <select onChange={(e) => {
                                    sessionStorage.setItem(sessionData.stUserName + '_selectedMid', e.target.value)
                                }} name="mid">
                                    <option value="">Select From Below</option>
                                    {
                                        homeMaster?.map((x) => (
                                            <option value={x.stMarketID}>
                                                {x.stMarketName}
                                            </option>
                                        ))
                                    }

                                </select>
                            </div>
                            {/* Modal Body */}
                            <div className="modal-body">
                                {isLoading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status"></div>
                                        <p className="mt-2">Loading markets...</p>
                                    </div>
                                ) : (
                                    <div className="table-responsive">
                                        <table style={{ minHeight: '400px' }} className="table table-bordered table-striped table-hover align-middle">
                                            <thead className="table-dark text-center">
                                                <tr>
                                                    <th>Market Name</th>
                                                    <th>Runner</th>
                                                    <th>
                                                        <div className="d-flex justify-content-center gap-3">
                                                            <span className="badge bg-info">Back</span>
                                                            <span className="badge bg-danger">Lay</span>
                                                        </div>
                                                    </th>
                                                    <th>Start</th>
                                                    <th>Ball Running</th>
                                                    <th>Close</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {homeMaster?.filter(x => selectedMid && selectedMid !== "" ? x.stMarketID == selectedMid : 0)?.map((d) => (

                                                    <tr key={d.stMarketID} style={{
                                                    }}>
                                                        {/* Market Name + Market Qty */}
                                                        <td style={{
                                                            position: "relative",
                                                            minWidth: "300px"
                                                        }}>
                                                            <div className='d-flex ' style={{
                                                                justifyContent: "space-evenly",
                                                                position: "absolute",
                                                                padding: "14px",
                                                                inset: 0,
                                                                flexDirection: "column",
                                                                gap: "30px",
                                                            }}>
                                                                <div className="fw-bold w-100" style={{
                                                                    textAlign: "center"
                                                                }}>{d.stMarketName}
                                                                    <button onClick={() => setmessagemodal(true)} className='btn btn-success text-sm btn-sm'>
                                                                        Message
                                                                    </button>
                                                                </div>
                                                                <input
                                                                    className="form-control form-control-sm mt-2 d-none"
                                                                    placeholder="Market Qty"
                                                                    type="number"
                                                                    value={selectedpricebtn?.filter((item, index) => (item?.stMarketID == d?.stMarketID))?.[0]?.value || 0}
                                                                    id={d.stMarketID + "_marketqty"}
                                                                    onKeyDown={async (evt) => {
                                                                        if (evt.keyCode === 9) {
                                                                            const currentValue = evt.currentTarget?.value;
                                                                            const savedData = JSON.parse(
                                                                                localStorage.getItem("savedata") || "[]"
                                                                            );
                                                                            const marketIndex = savedData.findIndex(
                                                                                (a) => a.stMarketID === d.stMarketID
                                                                            );

                                                                            if (marketIndex >= 0) {
                                                                                savedData[marketIndex][
                                                                                    d.stMarketID + "_marketqty"
                                                                                ] = parseFloat(currentValue);
                                                                            } else {
                                                                                savedData.push({
                                                                                    stMarketID: d.stMarketID,
                                                                                    [d.stMarketID + "_marketqty"]:
                                                                                        parseFloat(currentValue),
                                                                                });
                                                                            }

                                                                            localStorage.setItem(
                                                                                "savedata",
                                                                                JSON.stringify(savedData)
                                                                            );
                                                                            await addTossMarketPrice(d);
                                                                        }
                                                                    }}
                                                                />
                                                                <div className='chipsbtn' >
                                                                    {
                                                                        pricebtn?.map((item, index) => (
                                                                            <button className='btn btn-success text-sm btn-sm' onClick={(e) => {
                                                                                for (let i = 0; i < d.submaster.length; i++) {
                                                                                    const element = d.submaster[i];
                                                                                    try {
                                                                                        let doc = document.getElementById('selectbacks_' + element.stInstrumentID)
                                                                                        doc.value = parseFloat(item)
                                                                                        let doc2 = document.getElementById('layruns_' + element.stInstrumentID)
                                                                                        doc2.value = parseFloat(item)
                                                                                    } catch (error) {

                                                                                    }
                                                                                }
                                                                                // dispatch(addpricebtn({ ...d, value: item }))
                                                                            }}>
                                                                                {item}

                                                                            </button>
                                                                        ))
                                                                    }
                                                                </div>
                                                            </div>
                                                        </td>

                                                        {/* Runner Names */}
                                                        <td>
                                                            {d?.submaster?.map((n) => (
                                                                <div
                                                                    key={n.stInstrumentID}
                                                                    className="d-flex justify-content-center gap-2 mb-2"
                                                                >
                                                                    <button onClick={() => {
                                                                        const runnerStatus = sessionStorage.getItem(n.stInstrumentID)
                                                                        if (runnerStatus) {
                                                                            sessionStorage.removeItem(n.stInstrumentID)
                                                                        } else {
                                                                            sessionStorage.setItem(n.stInstrumentID, 3)
                                                                        }
                                                                    }} className='btn btn-success text-sm btn-sm'>Withdraw</button>
                                                                    <input
                                                                        className="form-control form-control-sm text-center"
                                                                        style={{ width: '200px', height: '40px', background: 'transparent', border: 'none' }}
                                                                        disabled
                                                                        value={n.stRunnerName}
                                                                    />
                                                                </div>
                                                            ))}
                                                        </td>

                                                        {/* Price Controls */}
                                                        <td>
                                                            {d?.submaster?.map((n) => (
                                                                <div
                                                                    key={n.stInstrumentID}
                                                                    className="d-flex justify-content-center gap-2 mb-2"
                                                                >
                                                                    {/* <button className='btn btn-success btn-sm' style={{
                                                                        minWidth: "50px"
                                                                    }} onClick={(e) => {


                                                                    }}>
                                                                        {selectedpricebtn?.filter((item, index) => (item?.stMarketID == d?.stMarketID))[0]?.value || 0}

                                                                    </button> */}
                                                                    <input onKeyDown={async (evt) => {
                                                                        if (evt.keyCode === 9) {
                                                                            const currentValue = evt.currentTarget.value
                                                                            const savedData = JSON.parse(localStorage.getItem('savedata') || '[]')
                                                                            const marketIndex = savedData.findIndex(a => a.stMarketID === d.stMarketID)
                                                                            if (marketIndex >= 0) { savedData[marketIndex][n.stSelectionID + "_bsize"] = parseFloat(currentValue) } else { savedData.push({ stMarketID: d.stMarketID, [n.stSelectionID + "_bsize"]: parseFloat(currentValue) }) } localStorage.setItem('savedata', JSON.stringify(savedData))
                                                                            await addTossMarketPrice(d)
                                                                        }
                                                                    }} className='form-control form-control-sm text-center' style={{ height: '40px', width: '140px' }} defaultValue={d.submaster?.find(a => a.stInstrumentID === n.stInstrumentID)?.rates?.Back[0]?.Size || 0} id={'selectbacks_' + n.stInstrumentID} placeholder='Back_Size' type="number" />
                                                                    {/* Back Price */}

                                                                    <input
                                                                        className="form-control form-control-sm text-center"
                                                                        defaultValue={
                                                                            d.submaster?.find(
                                                                                (a) =>
                                                                                    a.stInstrumentID === n.stInstrumentID
                                                                            )?.rates?.Back[0]?.Price || 0
                                                                        }
                                                                        id={"selectback1_" + n.stInstrumentID}
                                                                        style={{ width: '200px' }}
                                                                        placeholder="Back"
                                                                        type="number"
                                                                        onKeyDown={async (evt) => {
                                                                            if (evt.keyCode === 9) {
                                                                                const currentValue =
                                                                                    evt.currentTarget.value;
                                                                                const savedData = JSON.parse(
                                                                                    localStorage.getItem("savedata") || "[]"
                                                                                );
                                                                                const marketIndex = savedData.findIndex(
                                                                                    (a) => a.stMarketID === d.stMarketID
                                                                                );

                                                                                if (marketIndex >= 0) {
                                                                                    savedData[marketIndex][
                                                                                        n.stSelectionID + "_bprice"
                                                                                    ] = parseFloat(currentValue);
                                                                                } else {
                                                                                    savedData.push({
                                                                                        stMarketID: d.stMarketID,
                                                                                        [n.stSelectionID + "_bprice"]:
                                                                                            parseFloat(currentValue),
                                                                                    });
                                                                                }

                                                                                localStorage.setItem(
                                                                                    "savedata",
                                                                                    JSON.stringify(savedData)
                                                                                );
                                                                                await addTossMarketPrice(d);
                                                                            }
                                                                        }}
                                                                    />

                                                                    {/* Lay Price */}
                                                                    <input
                                                                        className="form-control form-control-sm text-center"
                                                                        style={{ width: '200px' }}
                                                                        defaultValue={
                                                                            d.submaster?.find(
                                                                                (a) =>
                                                                                    a.stInstrumentID === n.stInstrumentID
                                                                            )?.rates?.Lay[0]?.Price || 0
                                                                        }
                                                                        id={"layrun1_" + n.stInstrumentID}
                                                                        placeholder="Lay"
                                                                        type="number"
                                                                        onKeyDown={async (evt) => {
                                                                            if (evt.keyCode === 9) {
                                                                                const currentValue =
                                                                                    evt.currentTarget?.value;
                                                                                const savedData = JSON.parse(
                                                                                    localStorage.getItem("savedata") || "[]"
                                                                                );
                                                                                const marketIndex = savedData.findIndex(
                                                                                    (a) => a.stMarketID === d.stMarketID
                                                                                );

                                                                                if (marketIndex >= 0) {
                                                                                    savedData[marketIndex][
                                                                                        n.stSelectionID + "_lprice"
                                                                                    ] = parseFloat(currentValue);
                                                                                } else {
                                                                                    savedData.push({
                                                                                        stMarketID: d.stMarketID,
                                                                                        [n.stSelectionID + "_lprice"]:
                                                                                            parseFloat(currentValue),
                                                                                    });
                                                                                }

                                                                                localStorage.setItem(
                                                                                    "savedata",
                                                                                    JSON.stringify(savedData)
                                                                                );
                                                                                await addTossMarketPrice(d);
                                                                            }
                                                                        }}
                                                                    />
                                                                    <input onKeyDown={async (evt) => {
                                                                        if (evt.keyCode === 9) {
                                                                            const currentValue = evt.currentTarget.value
                                                                            const savedData = JSON.parse(localStorage.getItem('savedata') || '[]')
                                                                            const marketIndex = savedData.findIndex(a => a.stMarketID === d.stMarketID)
                                                                            if (marketIndex >= 0) { savedData[marketIndex][n.stSelectionID + "_lsize"] = parseFloat(currentValue) } else { savedData.push({ stMarketID: d.stMarketID, [n.stSelectionID + "_lsize"]: parseFloat(currentValue) }) } localStorage.setItem('savedata', JSON.stringify(savedData))
                                                                            await addTossMarketPrice(d)
                                                                        }
                                                                    }} style={{ height: '40px', width: '140px' }} defaultValue={d.submaster?.find(a => a.stInstrumentID === n.stInstrumentID)?.rates?.Lay[0]?.Size || 0} id={'layruns_' + n.stInstrumentID} className='form-control form-control-sm text-center' placeholder={'Lay_Size_' + n.stRunnerName} type="number" />
                                                                    {/* <button className='btn btn-success btn-sm' style={{
                                                                        minWidth: "50px"
                                                                    }} onClick={(e) => {


                                                                    }}>
                                                                        {selectedpricebtn?.filter((item, index) => (item?.stMarketID == d?.stMarketID))[0]?.value || 0}

                                                                    </button> */}
                                                                </div>
                                                            ))}
                                                        </td>

                                                        {/* Actions */}
                                                        <td className="text-center">
                                                            <button
                                                                onClick={() => {
                                                                    resumeMarket(d.stMarketID);
                                                                    suspendHorse(d, 1);
                                                                }}
                                                                className={`btn btn-${susMarkets.includes(d.stMarketID) ? 'danger' : 'success'} btn-sm`}
                                                            >
                                                                Start
                                                            </button>
                                                        </td>
                                                        <td className="text-center">
                                                            <button
                                                                onClick={() => suspendHorse(d, 2)}
                                                                className={`btn btn-${susMarkets.includes(d.stMarketID) ? 'success' : 'danger'} btn-sm`}
                                                            >
                                                                Running
                                                            </button>
                                                        </td>
                                                        <td className="text-center">
                                                            <button
                                                                onClick={() => setCloseHorse(d)}
                                                                className="btn btn-warning btn-sm"
                                                            >
                                                                Close
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {
                messagemodal &&
                <div class="modal fade show" aria-modal="true" role="dialog" style={{ display: "block" }}>
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header text-dark">
                                <h1 id="book-deal-popupLabel" class="modal-title fs-5 text-uppercase">Add Horse Market Message</h1>
                                <button onClick={() => {
                                    setmessage('')
                                    setmessagemodal(false)
                                }} type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"></button>
                            </div>
                            <div class="modal-body d-flex flex-column">
                                <form>
                                    <div>
                                        <label htmlFor="">Message</label>
                                        <input className='form-control' placeholder='Put race message here' type="text" onChange={(e) => {
                                            setmessage(e.target.value)
                                        }} value={message} />
                                    </div>
                                </form>
                                <button onClick={() => {
                                    updateMessage(selectedMid, message).then((data) => {
                                        setmessagemodal(false)
                                        setmessage('')
                                        toast.success("Message Updated")
                                    })
                                }} className='btn btn-success btn-lg'>Add</button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {closeHorse && (<div id="Horse-Market" className="modal fade show" aria-modal="true" role="dialog" style={{ display: "block" }}> <div className="modal-dialog"> <div className="modal-content"> <div className="modal-header text-dark"> <h1 id="book-deal-popupLabel" className="modal-title fs-5 text-uppercase"> Give Result for {closeHorse.stEventName} - {closeHorse.stMarketName} </h1> <button onClick={() => setCloseHorse(null)} type="button" data-bs-dismiss="modal" aria-label="Close" className="btn-close" /> </div> <div className="modal-body d-flex flex-column"> <form> {closeHorse.submaster?.map((a) => (<div key={a.stSelectionID} style={{ marginBottom: "10px" }} className='d-flex flex-column'> <div className='d-flex align-items-center justify-content-between gap-2'> <label>({a.stSelectionID}){a.stRunnerName}</label> <select id={"horsestat_" + a.stSelectionID}> <option value="LOSER">LOSER</option> <option value="ACTIVE">ACTIVE</option> <option value="REMOVED">REMOVED</option> <option value="WINNER">WINNER</option> </select> <div className='d-flex align-items-end gap-2'> <input style={{ width: '100px' }} placeholder='remove %' type="number" id={"adfac_" + a.stSelectionID} /> </div> <div className='d-flex align-items-end gap-2'> <input style={{ width: '100px' }} placeholder='Extra Remark For winner' type="number" id={"exremwin_" + a.stSelectionID} /> </div> </div> </div>))} </form> <button onClick={() => openClosingHorse(closeHorse)} className='btn btn-success btn-lg' > Add </button> </div> </div> </div> </div>)}
        </>
    )
}